module.exports = function(
  $scope,
  $timeout,
  countryResolve,
  GeocodeService,
  gettextCatalog,
  industryResolve,
  Notification,
  Office,
  OfficeModel,
  officeResolve,
  Upload,
) {
  $scope.office = officeResolve;
  $scope.industries = industryResolve;
  $scope.mapLink = null;
  $scope.showValidation = false;
  $scope.tasks = [
    { text: gettextCatalog.getString('You added your address'), weight: 15, completed: false },
    { text: gettextCatalog.getString('You added your contact data'), weight: 15, completed: false },
    { text: gettextCatalog.getString('You uploaded your logo'), weight: 20, completed: false },
    {
      text: gettextCatalog.getString('You activated your profile for the booking system.'),
      weight: 10,
      completed: false,
    },
    {
      text: gettextCatalog.getString('You uploaded pictures of you office'),
      weight: 20,
      completed: false,
    },
    { text: gettextCatalog.getString('You added a discription'), weight: 20, completed: false },
  ];

  $scope.countries = countryResolve;

  $scope.changeIndustry = function() {
    angular.forEach($scope.industries, function(value) {
      if (value.name === $scope.office.profile.industry) {
        $scope.office.settings.customLabels = value.labels;
      }
    });
  };

  function sumcompletedTasksWeight() {
    $scope.completedTasksWeight = 0;

    // check address
    if (
      $scope.office.name &&
      $scope.office.address &&
      angular.isArray($scope.office.address.location) &&
      $scope.office.address.location.length === 2
    ) {
      $scope.tasks[0].completed = true;
    } else {
      $scope.tasks[0].completed = false;
    }

    // check contacts
    if ($scope.office.profile.contacts.phone && $scope.office.profile.contacts.email) {
      $scope.tasks[1].completed = true;
    } else {
      $scope.tasks[1].completed = false;
    }

    // check logo
    if ($scope.office.profile.logo) {
      $scope.tasks[2].completed = true;
    } else {
      $scope.tasks[2].completed = false;
    }

    // check profile active
    if ($scope.office.profile.public) {
      $scope.tasks[3].completed = true;
    } else {
      $scope.tasks[3].completed = false;
    }

    // check images
    if ($scope.office.profile.images && $scope.office.profile.images.length > 0) {
      $scope.tasks[4].completed = true;
    } else {
      $scope.tasks[4].completed = false;
    }

    // check text
    if ($scope.office.profile.text) {
      $scope.tasks[5].completed = true;
    } else {
      $scope.tasks[5].completed = false;
    }

    angular.forEach($scope.tasks, function(task) {
      if (task.completed) {
        $scope.completedTasksWeight += task.weight;
      }
    });
  }

  sumcompletedTasksWeight();

  // if address is not set
  if (!$scope.office.address) {
    $scope.office.address = {
      location: [],
      city: {
        name: '',
      },
    };
  }

  // set logo
  if ($scope.office.profile.logo) {
    $scope.logoPreview = 'files/logos/' + $scope.office.profile.logo;
  }

  $scope.generateMapLink = function() {
    if (
      $scope.office.address &&
      angular.isArray($scope.office.address.location) &&
      $scope.office.address.location.length === 2
    ) {
      $scope.mapLink =
        '//maps.googleapis.com/maps/api/staticmap?center=' +
        $scope.office.address.location[1] +
        ',' +
        $scope.office.address.location[0] +
        '&zoom=15&size=785x300&maptype=roadmap&&markers=color:0x9BBF4D|' +
        $scope.office.address.location[1] +
        ',' +
        $scope.office.address.location[0] +
        '&sensor=false';
    }
  };

  $scope.generateMapLink();

  /**
   * generate logo preview
   * @param $files
   */
  $scope.onFileSelect = function($files) {
    $scope.$files = $files;
    for (var i = 0; i < $scope.$files.length; i++) {
      var file = $scope.$files[i];

      if (window.FileReader && file.type.indexOf('image') > -1) {
        var fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = function(e) {
          $timeout(function() {
            $scope.logoPreview = e.target.result;
          });
        };
      }
    }
  };

  $scope.onCarouselFileSelect = function($files) {
    if (angular.isArray($files) && $files.length > 0) {
      Upload.upload({
        url: '/api/office/' + $scope.office._id + '/imageUpload',
        data: {},
        file: $files[0],
      })
        .success(function(data) {
          $scope.office.profile.images.push({
            name: data.name + '?decache=' + new Date().getTime(),
            title: '',
          });
          saveToDB();
        })
        .error(function(error) {
          if (error.message === 'file_to_large') {
            Notification.addErrorMessage(
              gettextCatalog.getString('Image file is to large (max 1.0 MB)'),
            );
          } else if (error.message === 'extension_not_allowed') {
            Notification.addErrorMessage(
              gettextCatalog.getString('Image file extension not of type [JPG,PNG]'),
            );
          } else {
            Notification.addErrorMessage({ text: error.message });
          }
          saveToDB();
        });
    }
  };

  $scope.removeImage = function(image) {
    Office.deleteImage(
      { embeddedDocument: image.name, officeId: $scope.office._id },
      function() {
        var index = $scope.office.profile.images.indexOf(image);
        $scope.office.profile.images.splice(index, 1);
        Notification.addSuccessMessage(gettextCatalog.getString('Image deleted'));
      },
      function() {
        Notification.addErrorMessage(gettextCatalog.getString('Cant delete image'));
      },
    );
  };

  /**
   * save to rest webservice
   */
  $scope.save = function() {
    $scope.showValidation = true;

    // upload logo
    if ($scope.$files) {
      Upload.upload({
        url: '/api/office/' + $scope.office._id + '/logoupload',
        data: {},
        file: $scope.$files,
      })
        .progress(function(evt) {
          console.log('upload:' + parseInt((100.0 * evt.loaded) / evt.total));
        })
        .success(function(data, status, headers, config) {
          $scope.office.profile.logo = data + '?decache=' + new Date().getTime(); //
          saveToDB();
        })
        .error(function(error) {
          if (error.message == 'file_to_large') {
            Notification.addErrorMessage(
              gettextCatalog.getString('Image file is to large (max 1.0 MB)'),
            );
          } else if (error.message == 'extension_not_allowed') {
            Notification.addErrorMessage(
              gettextCatalog.getString('Image file extension not of type [JPG,PNG]'),
            );
          } else {
            Notification.addErrorMessage({ text: error.message });
          }

          saveToDB();
        });
    } else {
      saveToDB();
    }
  };

  function saveToDB() {
    var address =
      $scope.office.address.street +
      ', ' +
      $scope.office.address.postal +
      ' ' +
      $scope.office.address.city.name;

    GeocodeService.getGeoData(address, function(error, response) {
      if (error) {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant find address. Please check again'),
        );
      } else {
        // TODO: set lat lng in backend
        if (response && response.geometry) {
          if (response.geometry.location) {
            $scope.office.address.location = [
              response.geometry.location.lng,
              response.geometry.location.lat,
            ];
          }

          if (angular.isArray(response.address_components)) {
            // check for district
            for (var i = 0; i < response.address_components.length; i++) {
              if (response.address_components[i].types.indexOf('sublocality') > -1) {
                $scope.office.address.city.district = response.address_components[i].long_name;
                break;
              }
            }

            // get country, walk array from end to start cause country is mostly in one of the last array elements
            for (var i = response.address_components.length - 1; i >= 0; i--) {
              if (response.address_components[i].types.indexOf('country') > -1) {
                $scope.office.address.country = response.address_components[i].long_name;
                $scope.office.address.countryCode = response.address_components[i].short_name || '';
                break;
              }
            }

            // get country code
            $scope.generateMapLink();
          }
        }

        if ($scope.ProfileForm.$valid) {
          OfficeModel.update($scope.office, function(error, response) {
            if (error) {
              Notification.addErrorMessage({ text: error });
            } else {
              Notification.addSuccessMessage(gettextCatalog.getString('Profile saved'));
              $scope.office = response;
              sumcompletedTasksWeight();
            }
          });
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/modules/profile/profileCtrl.js